let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  //Checkout btn Test
  const c_Checkout_btn_Test = window.igData?.user.getTestGroup(
    "67867c61-bfce-4c92-8cd0-42dbbfea5d76"
  );
  if (c_Checkout_btn_Test?.name === "Var A") {
    document.body.classList.add("checkout-test-VarA");
  } else if (c_Checkout_btn_Test?.name === "Var B") {
    document.body.classList.add("checkout-test-VarB");
  }
  
  //Header menu cart label Test
  const c_Header_Test = window.igData?.user.getTestGroup(
    "a08f6a02-2a75-45a3-9db9-9706343e8685"
  );
  if (c_Header_Test?.name === "Var A") {
    document.body.classList.add("c-menu-cart-label-test-VarA");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
